var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ordenedArrays)?_c('div',{staticClass:"container-graph"},_vm._l((_vm.ordenedArrays),function(column){return _c('column',{key:column.id,staticClass:"column",attrs:{"year":column.year}},_vm._l((column.actives),function(cell){return _c('div',{key:cell.id,staticClass:"celulas"},[_c('cell',{attrs:{"cell":cell}})],1)}),0)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }